import React, { forwardRef, useMemo } from 'react';
import { TicketTextInfoWarp, TicketTextInfoContent } from './components';
import Test from './components/Test';
import Email from './components/Email';
import TextMessage from './components/TextMessage';
import Remark from './components/Remark';
import Call from './components/Call';
import ChangeRecord from './components/ChangeRecord';
import { TicketType } from 'src/components/common/TicketTypeSelect/const';

interface TemplateProps {
    item?: any;
    isLastItem?: any;
    content?: any;
    itemKey?: any;
    titleRef?: any;
    isTest?: boolean;
}

const Template = forwardRef((props: TemplateProps, ref: any) => {
    const { item, isLastItem, content, itemKey, titleRef, isTest } = props;

    const type = useMemo(() => item?.data?.replyType, [item?.data?.replyType]);

    return (
        <TicketTextInfoWarp className="audio-call-content-view-custom-text-info-view" key={itemKey}>
            <TicketTextInfoContent isLastItem={isLastItem}>
                {isTest ? (
                    <Test item={item} content={content} titleRef={titleRef} ref={ref} />
                ) : type === TicketType.EMAIL ? (
                    <Email item={item} content={content} titleRef={titleRef} ref={ref} />
                ) : type === TicketType.TEXTMSG ? (
                    <TextMessage item={item} content={content} titleRef={titleRef} ref={ref} />
                ) : type === TicketType.REMARK ? (
                    <Remark item={item} content={content} titleRef={titleRef} ref={ref} />
                ) : type === TicketType.CALL ? (
                    <Call item={item} content={content} titleRef={titleRef} ref={ref} />
                ) : type === TicketType.CHANGERECORD ? (
                    <ChangeRecord item={item} content={content} titleRef={titleRef} ref={ref} />
                ) : null}
            </TicketTextInfoContent>
        </TicketTextInfoWarp>
    );
});

export default React.memo(Template);
